// src/views/CRM/Collections/dummyCollectionsData.js

export const dummyCollectionsData = [
  {
    id: 1,
    cliente: 'Empresa Constructora Los Andes S.A.',
    servicio: 'Asesoría Legal Corporativa',
    montoPendiente: 4500000,
    cuotas: 3,
    vencimiento: '2025-09-15',
    estado: 'Vencido',
  },
  {
    id: 2,
    cliente: 'Inversiones del Sur Ltda.',
    servicio: 'Litigio Civil',
    montoPendiente: 2800000,
    cuotas: 2,
    vencimiento: '2025-10-01',
    estado: 'Vencido',
  },
  {
    id: 3,
    cliente: 'Comercial Santiago SpA',
    servicio: 'Defensa Laboral',
    montoPendiente: 1500000,
    cuotas: 1,
    vencimiento: '2025-10-08',
    estado: 'Vencido',
  },
  {
    id: 4,
    cliente: 'Transportes Norte Grande S.A.',
    servicio: 'Asesoría Tributaria',
    montoPendiente: 6200000,
    cuotas: 4,
    vencimiento: '2025-10-20',
    estado: 'Pendiente',
  },
  {
    id: 5,
    cliente: 'Desarrollos Inmobiliarios SpA',
    servicio: 'Regularización Inmobiliaria',
    montoPendiente: 3900000,
    cuotas: 2,
    vencimiento: '2025-10-25',
    estado: 'Pendiente',
  },
  {
    id: 6,
    cliente: 'Servicios Logísticos Chile Ltda.',
    servicio: 'Asesoría Legal Corporativa',
    montoPendiente: 2200000,
    cuotas: 5,
    vencimiento: '2025-10-30',
    estado: 'Pendiente',
  },
  {
    id: 7,
    cliente: 'Minera del Pacífico S.A.',
    servicio: 'Litigio Civil',
    montoPendiente: 8500000,
    cuotas: 1,
    vencimiento: '2025-11-05',
    estado: 'Vigente',
  },
  {
    id: 8,
    cliente: 'Agroexportadora Sur SpA',
    servicio: 'Defensa Laboral',
    montoPendiente: 1800000,
    cuotas: 3,
    vencimiento: '2025-11-10',
    estado: 'Vigente',
  },
];
